import { render, staticRenderFns } from "./StudyProgramListItem.vue?vue&type=template&id=6c91ae31&scoped=true&"
import script from "./StudyProgramListItem.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramListItem.vue?vue&type=script&lang=ts&"
import style0 from "./StudyProgramListItem.vue?vue&type=style&index=0&id=6c91ae31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c91ae31",
  null
  
)

export default component.exports